import request from '@/utils/request'

// 自定义分类表

let DiycategoryApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.diycategory/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.diycategory/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.diycategory/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.diycategory/edit', data, errorback);
    },

    /*状态*/
    status(data, errorback) {
      return request._post('/shop/study.diycategory/status', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.diycategory/batch', data, errorback);
    },
}

export default DiycategoryApi;



// WEBPACK FOOTER //
// ./src/api/study/diycategory.js